import React, {
  createContext,
  useContext,
  useState,
  ReactNode,
  useMemo,
} from "react";

interface NavbarContextType {
  isOpen: boolean;
  toggleNavbar: (value: boolean) => void;
}

interface NavbarProviderProps {
  children: ReactNode;
}

const NavbarContext = createContext<NavbarContextType | undefined>(undefined);

export function useNavbar() {
  const context = useContext(NavbarContext);
  if (!context) {
    throw new Error("useNavbar must be used within a NavbarProvider");
  }
  return context;
}

export function NavbarProvider({ children }: NavbarProviderProps) {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = (value: boolean) => {
    setIsOpen(value);
  };

  const contextValue = useMemo(() => ({ isOpen, toggleNavbar }), [isOpen]);

  return (
    <NavbarContext.Provider value={contextValue}>
      {children}
    </NavbarContext.Provider>
  );
}
